module.exports = __webpack_public_path__ + "fonts/NespressoLucas-Italic.svg?v=2f80b51a0f8992c6d1bd6ba18c37687d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-Italic.svg
// module id = 630
// module chunks = 0